import { O_03, OTHER_DEFAULTS } from "@stadium/shared/src/helpers/plasmic/static-slices";

export const O03_PLASMIC_PROPS = {
  cards: {
    type: "array",
    itemType: {
      type: "object",
      fields: {
        image: {
          type: "imageUrl",
        },
        imageAlt: {
          type: "string",
        },
        cardTitle: {
          type: "string",
        },
        description1: {
          type: "string",
        },
        description2: {
          type: "string",
        },
        description3: {
          type: "string",
        },
      },
    },
    defaultValue: OTHER_DEFAULTS[O_03].cards,
    description: "Cards array for O03 component",
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
